const HistoryStatus = Object.freeze({
    NEED_PROCESS: "NEED_PROCESS",
    PROCESSED: "PROCESSED",
    PROCESSED_MANUAL: "PROCESSED_MANUAL",
    PROCESSED_MANUAL_ERROR: "PROCESSED_MANUAL_ERROR",
});

module.exports = HistoryStatus;